export const FETCH_ACCOUNT_BY_ID_REQUEST = 'FETCH_ACCOUNT_BY_ID_REQUEST';
export const FETCH_ACCOUNT_BY_ID_SUCCESS = 'FETCH_ACCOUNT_BY_ID_SUCCESS';
export const FETCH_ACCOUNT_BY_ID_FAILED = 'FETCH_ACCOUNT_BY_ID_FAILED';

export const FETCH_ACCOUNT_CREDIT_BY_ID_REQUEST = 'FETCH_ACCOUNT_CREDIT_BY_ID_REQUEST';
export const FETCH_ACCOUNT_CREDIT_BY_ID_SUCCESS = 'FETCH_ACCOUNT_CREDIT_BY_ID_SUCCESS';
export const FETCH_ACCOUNT_CREDIT_BY_ID_FAILED = 'FETCH_ACCOUNT_CREDIT_BY_ID_FAILED';

export const FETCH_UPDATE_CUSTOMER_ACCOUNT_REQUEST = 'FETCH_UPDATE_CUSTOMER_ACCOUNT_REQUEST';
export const FETCH_UPDATE_CUSTOMER_ACCOUNT_SUCCESS = 'FETCH_UPDATE_CUSTOMER_ACCOUNT_SUCCESS';
export const FETCH_UPDATE_CUSTOMER_ACCOUNT_FAILED = 'FETCH_UPDATE_CUSTOMER_ACCOUNT_FAILED';
export const RESET_UPDATE_ACCOUNT = 'RESET_UPDATE_ACCOUNT';

export const FETCH_ADD_CREDIT_REQUEST = 'FETCH_ADD_CREDIT_REQUEST';
export const FETCH_ADD_CREDIT_SUCCESS = 'FETCH_ADD_CREDIT_SUCCESS';
export const FETCH_ADD_CREDIT_FAILED = 'FETCH_ADD_CREDIT_FAILED';
export const RESET_ADD_CREDIT = 'RESET_ADD_CREDIT';

export const FETCH_ADD_NFC_CARD_REQUEST = 'FETCH_ADD_NFC_CARD_REQUEST';
export const FETCH_ADD_NFC_CARD_SUCCESS = 'FETCH_ADD_NFC_CARD_SUCCESS';
export const FETCH_ADD_NFC_CARD_FAILED = 'FETCH_ADD_NFC_CARD_FAILED';
export const RESET_ADD_NFC_CARD = 'RESET_ADD_NFC_CARD';

export const FETCH_REVOKE_CREDIT_REQUEST = 'FETCH_REVOKE_CREDIT_REQUEST';
export const FETCH_REVOKE_CREDIT_SUCCESS = 'FETCH_REVOKE_CREDIT_SUCCESS';
export const FETCH_REVOKE_CREDIT_FAILED = 'FETCH_REVOKE_CREDIT_FAILED';

export const FETCH_INVITE_USER_REQUEST = 'FETCH_INVITE_USER_REQUEST';
export const FETCH_INVITE_USER_SUCCESS = 'FETCH_INVITE_USER_SUCCESS';
export const FETCH_INVITE_USER_FAILED = 'FETCH_INVITE_USER_FAILED';

export const RESET_INVITE_FORM_ERRORS = 'RESET_INVITE_FORM_ERRORS';
